import { useCallback, useState } from 'react'

import { EmbroideryTypeKey } from '../../../../../containers/EmbroideryContainer/combination-rules/types'
import { TYPE_KEY_BY_FORM_KIND } from '../../../../../containers/EmbroideryContainer/providers/embroideryTypeKeys'
import { ExternalEmbroideryFormKind } from '../../../../../containers/EmbroideryContainer/providers/facade'

/**
 * Whether the DTC modal is open and which editor it opens on, driven by the page's CTA and
 * summary card through the embroidery contract: they pick a kind, then open.
 *
 * `openCount` changes on every open. Use it as the modal's `key`, so each open starts fresh on
 * the chosen editor instead of wherever the customer left the last one.
 */
export function useDtcEmbroideryModalState() {
  const [isOpen, setIsOpen] = useState(false)
  const [openCount, setOpenCount] = useState(0)
  const [initialTypeKey, setInitialTypeKey] = useState<EmbroideryTypeKey | null>(null)

  const selectFormKind = useCallback((formKind: ExternalEmbroideryFormKind | null) => {
    setInitialTypeKey(formKind === null ? null : TYPE_KEY_BY_FORM_KIND[formKind])
  }, [])

  const open = useCallback(() => {
    setOpenCount(count => count + 1)
    setIsOpen(true)
  }, [])

  // Closing forgets the kind, so a plain open afterwards lands on the option list.
  const close = useCallback(() => {
    setInitialTypeKey(null)
    setIsOpen(false)
  }, [])

  return { isOpen, openCount, initialTypeKey, selectFormKind, open, close }
}
